export default __webpack_public_path__ + "static/media/imgpost2.02a40db9.jpg";